import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  _RouteRecordBase,
} from "vue-router";
import HomeView from "@/views/HomeView.vue";
import LoginPage from "@/views/LoginPage.vue";
import CustomerList from "@/views/CustomerList.vue";
import UserList from "@/views/UserList.vue";
import UserCreate from "@/views/UserCreate.vue";
import CarList from "@/views/CarList.vue";
import WorkstationManagement from "@/views/WorkstationManagement.vue";
import VehicleManagement from "@/views/VehicleManagement.vue";
import OrgUserManagement from "@/views/OrgUserManagement.vue";
import VehicleList from "@/views/VehicleList.vue";
import ScheduledTasks from "../views/ScheduledTasks.vue";
import BasicInformation from "@/views/BasicInformation.vue";
import VisualizationPage from "@/views/VisualizationPage.vue";
import DataStatistics from "@/views/DataStatistics.vue";
import CarDataStatistics from "@/views/CarDataStatistics.vue";
import CarDataStatisticsDetail from "@/views/CarDataStatisticsDetail.vue";
import SecuritySet from "@/views/SecuritySet.vue";
import UserManageList from "@/views/UserManageList.vue";
import AddUser from "@/views/AddUser.vue";
import CustomerCreate from "@/views/CustomerCreate.vue";
import UnattendedList from "../views/UnattendedList.vue";
import VehicleControl from "../views/VehicleControl.vue";
import Dashboard from "../views/Dashboard.vue";
import { message } from "ant-design-vue";

import routerName from "./routerName";
declare module "vue-router" {
  interface _RouteRecordBase {
    icon?: boolean | string | number;
    id?: string;
  }
}
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "登录",
    component: LoginPage,
  },
  {
    path: routerName.home,
    name: "场地管理",
    component: HomeView,
    id: "20",
    icon: "ShopOutlined",
    children: [
      {
        path: routerName.customerList,
        name: "场地列表",
        component: CustomerList,
      },
      {
        path: routerName.customerCreate,
        name: "新建场地",
        component: CustomerCreate,
      },
      {
        path: routerName.usermanagement,
        name: "用户列表",
        component: UserList,
      },
      {
        path: routerName.userCreate,
        name: "新增用户",
        component: UserCreate,
      },
      {
        path: routerName.uservehiclelist,
        name: "车辆列表",
        component: CarList,
      },
      {
        path: routerName.vehicleManagement,
        name: "关联车辆管理",
        component: VehicleManagement,
      },
      {
        path: routerName.WorkStationManagement,
        name: "工作站管理",
        component: WorkstationManagement,
      },
      {
        path: routerName.OrgUserManagement,
        name: "用户管理",
        component: OrgUserManagement,
      },
      {
        path: routerName.visualization,
        component: VisualizationPage,
        name: "资源管理",
      },
    ],
  },
  {
    path: routerName.carmanagement,
    name: "车辆管理",
    id: "1",
    component: HomeView,
    icon: "car-filled",
    children: [
      {
        path: routerName.vehiclelist,
        name: "总车辆列表",
        component: VehicleList,
      },
      {
        path: routerName.scheduledtasks,
        name: "定时任务",
        component: ScheduledTasks,
      },
      {
        path: routerName.basicInfo,
        component: BasicInformation,
        name: "车辆信息",
      },
    ],
  },
  {
    path: routerName.dashboard,
    name: "首页",
    component: HomeView,
    id: "0",
    icon: "HomeFilled",
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },
    ],
  },
  {
    path: routerName.operate,
    name: "运营",
    component: HomeView,
    id: "8",
    icon: "contacts-filled",
    children: [
      {
        path: routerName.datastatistics,
        name: "数据统计",
        component: DataStatistics,
      },
      {
        path: routerName.cardatastatistics,
        component: CarDataStatistics,
        name: "单车数据统计",
      },
      {
        path: routerName.cardatastatisticsdetail,
        component: CarDataStatisticsDetail,
        name: "任务详情",
      },
      {
        path: routerName.unattendedList,
        component: UnattendedList,
        name: "无人值守",
      },
      {
        path: routerName.vehiclecontrol,
        component: VehicleControl,
        name: "无人值守控制",
      },
    ],
  },
  {
    path: "/set",
    name: "设置",
    id: "11",
    component: HomeView,
    icon: "setting-filled",
    children: [
      {
        path: routerName.securityset,
        name: "安全设置",
        component: SecuritySet,
      },
      {
        path: routerName.usermanage,
        component: UserManageList,
        name: "平台用户管理",
      },
      {
        path: routerName.adduser,
        component: AddUser,
        name: "添加用户",
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.fullPath === "/") {
    next();
  } else {
    if (sessionStorage.getItem("token")) {
      next();
    } else {
      message.warning("请登录");
      next("/");
    }
  }
});
export default router;
